module.exports = __webpack_public_path__ + "static/media/img.91ef15b2.jpg";